const textFieldOperators = {
    contains: {
        value: "contains",
        key: "contains",
        target: "text"
    },
    doesNotContain: {
        value: "doesNotContain",
        key: "doesNotContain",
        target: "text"
    },
    equals: {
        value: "equals",
        key: "equals",
        target: "text"
    },
    doesNotEqual: {
        value: "doesNotEqual",
        key: "doesNotEqual",
        target: "text"
    },
    startsWith: {
        value: "startsWith",
        key: "startsWith",
        target: "text"
    },
    endsWith: {
        value: "endsWith",
        key: "endsWith",
        target: "text"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "text"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "text"
    }
};
const numberFieldOperators = {
    equals: {
        value: "equals",
        key: "equals",
        target: "number"
    },
    doesNotEqual: {
        value: "doesNotEqual",
        key: "doesNotEqual",
        target: "number"
    },
    greaterThan: {
        value: "greaterThan",
        key: "greaterThan",
        target: "number"
    },
    greaterThanOrEqual: {
        value: "greaterThanOrEqual",
        key: "greaterThanOrEqual",
        target: "number"
    },
    lessThan: {
        value: "lessThan",
        key: "lessThan",
        target: "number"
    },
    lessThanOrEqual: {
        value: "lessThanOrEqual",
        key: "lessThanOrEqual",
        target: "number"
    },
    between: {
        value: "between",
        key: "between",
        target: "number"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "number"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "number"
    }
};
const dateFieldOperators = {
    equals: {
        value: "equals",
        key: "equals",
        target: "date"
    },
    doesNotEqual: {
        value: "doesNotEqual",
        key: "doesNotEqual",
        target: "date"
    },
    before: {
        value: "before",
        key: "before",
        target: "date"
    },
    after: {
        value: "after",
        key: "after",
        target: "date"
    },
    between: {
        value: "between",
        key: "between",
        target: "date"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "date"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "date"
    }
};
const selectFieldOperators = {
    is: {
        value: "is",
        key: "is",
        target: "select"
    },
    isNot: {
        value: "isNot",
        key: "isNot",
        target: "select"
    },
    isAnyOf: {
        value: "isAnyOf",
        key: "isAnyOf",
        target: "select"
    },
    isNoneOf: {
        value: "isNoneOf",
        key: "isNoneOf",
        target: "select"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "select"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "select"
    }
};
const multiSelectFieldOperators = {
    hasAll: {
        value: "hasAll",
        key: "hasAll",
        target: "multiSelect"
    },
    hasAny: {
        value: "hasAny",
        key: "hasAny",
        target: "multiSelect"
    },
    hasNone: {
        value: "hasNone",
        key: "hasNone",
        target: "multiSelect"
    },
    hasExactly: {
        value: "hasExactly",
        key: "hasExactly",
        target: "multiSelect"
    },
    contains: {
        value: "contains",
        key: "contains",
        target: "multiSelect"
    },
    doesNotContain: {
        value: "doesNotContain",
        key: "doesNotContain",
        target: "multiSelect"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "multiSelect"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "multiSelect"
    }
};
const inputSelectFieldOperators = {
    is: {
        value: "is",
        key: "is",
        target: "input-select"
    },
    isNot: {
        value: "isNot",
        key: "isNot",
        target: "input-select"
    },
    contains: {
        value: "contains",
        key: "contains",
        target: "input-select"
    },
    doesNotContain: {
        value: "doesNotContain",
        key: "doesNotContain",
        target: "input-select"
    },
    isEmpty: {
        value: "isEmpty",
        key: "isEmpty",
        target: "input-select"
    },
    isNotEmpty: {
        value: "isNotEmpty",
        key: "isNotEmpty",
        target: "input-select"
    }
};
const fieldTypeOperatorDetails = {
    text: textFieldOperators,
    number: numberFieldOperators,
    date: dateFieldOperators,
    select: selectFieldOperators,
    multiSelect: multiSelectFieldOperators,
    "input-select": inputSelectFieldOperators
};
const operatorsWithoutValue = new Set([
    "isEmpty",
    "isNotEmpty"
]);
function operatorRequiresValue(operator) {
    return !operatorsWithoutValue.has(operator);
}
function getOperatorsForFieldType(fieldType) {
    return Object.values(fieldTypeOperatorDetails[fieldType]);
}
function getOperatorDetails(fieldType, operator) {
    return fieldTypeOperatorDetails[fieldType]?.[operator];
}
function formatOperatorLabel(operatorKey) {
    return operatorKey.replace(/([A-Z])/g, " $1").toLowerCase();
}
export { dateFieldOperators, fieldTypeOperatorDetails, formatOperatorLabel, getOperatorDetails, getOperatorsForFieldType, inputSelectFieldOperators, multiSelectFieldOperators, numberFieldOperators, operatorRequiresValue, operatorsWithoutValue, selectFieldOperators, textFieldOperators };
